import { cn } from "@/lib/utils";

export function TruCoinBadge({ className, size = "md" }: { className?: string; size?: "sm" | "md" | "lg" }) {
  const sizeClasses = {
    sm: "h-10 w-10 text-[10px]",
    md: "h-16 w-16 text-xs",
    lg: "h-24 w-24 text-sm",
  };

  return (
    <div
      className={cn(
        "relative flex items-center justify-center rounded-full",
        "bg-gradient-to-br from-brand via-brand to-brand-deep",
        "text-white font-display font-bold tracking-tight shadow-luxury",
        "ring-4 ring-white/40",
        sizeClasses[size],
        className,
      )}
    >
      <span className="relative z-10">T</span>
      <span
        aria-hidden
        className="absolute inset-0 rounded-full bg-gradient-to-tr from-white/20 to-transparent"
      />
      <span
        aria-hidden
        className="absolute -inset-1 rounded-full bg-brand/20 blur-xl"
      />
    </div>
  );
}
